<template>
	<div>
		<div>
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">
				补卡申请-{{ruleForm.id === null || ruleForm.id === '' ? '新增' : '修改'}}</div>
			<el-button
				style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
				@click="Return">返回</el-button>

			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px;overflow-x: hidden">
				<!-- 查询框 -->
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
					<el-row>
						<el-col :span="12">
							<div @click="StaffFind">
								<el-form-item label="补卡人" prop="staff_id" style="margin-top:80px;width:80%">
									<el-input style="width:595px" v-model="ruleForm.staff_name" onfocus="this.blur();">
									</el-input>
								</el-form-item>
							</div>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="补卡时间" prop="replacement_date">
								<el-date-picker v-model="ruleForm.replacement_date" style="width:595px" type="datetime"
									format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" placeholder="请选择">
								</el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="补卡原因" prop="replacement_reason">
								<el-input type="textarea" :rows="4" style="width:595px" placeholder="请输入代岗原因"
									v-model="ruleForm.replacement_reason">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="图片" prop="replacement_url">

								<el-upload :action="$globals.http + '/file/upload'" list-type="picture-card"
									:on-preview="handlePictureCardPreview" :limit="1" :on-remove="handleRemove"
									:on-success="handleAvatarSuccess">
									<i class="el-icon-plus"></i>
								</el-upload>
								<el-dialog :visible.sync="dialogVisible">
									<img width="100%" :src="ruleForm.replacement_url" alt="">
								</el-dialog>

							</el-form-item>
						</el-col>
					</el-row>

					<el-form-item style="margin-left:200px">
						<el-button type="goon" @click="AddAuditor()"
							v-show="ruleForm.id === null || ruleForm.id === ''">保存</el-button>
						<el-button type="goon" @click="UpdateAuditor()"
							v-show="ruleForm.id != null && ruleForm.id != ''">修改</el-button>
						<el-button type="addbtn" @click="resetForm('ruleForm')">重置</el-button>
					</el-form-item>
				</el-form>

			</div>

		</div>

		<el-dialog title="选择补卡人" :visible.sync="dialogVisible" width="40%" :center="true" :close-on-click-modal="false"
			:show-close="false">
			<el-row>
				<organizeStaff ref="organizeStaff" type="radio" :accordion="false" @commit="saveChange"
					:staff_id_prop="ruleForm.staff_id"></organizeStaff>
			</el-row>
			<el-row style="text-align: center;">
				<el-button type="goon" style="margin-top: 10px;" @click="$refs['organizeStaff'].commit()">确定</el-button>
			</el-row>
		</el-dialog>

		<el-dialog title="选择审核人" :visible.sync="dialogAuditorVisible" width="40%" :center="true"
			:close-on-click-modal="false">
			<SelectAuditor ref="SelectAuditor" :type="8" :examineDetailsList="ruleForm.examineDetailsList"
				:id="ruleForm.id"></SelectAuditor>
		</el-dialog>

	</div>
</template>

<script>
	import organizeStaff from '../../utils/organizeStaff/organizeStaff.vue';
	import SelectAuditor from '../SelectAuditor/SelectAuditor.vue';
	export default {
		components: {
			organizeStaff: organizeStaff,
			SelectAuditor: SelectAuditor,
		},
		props: ["organizeList"],
		data() {
			return {
				//表单数据
				ruleForm: {
					id: '',
					staff_id: '',
					staff_name: '',
					replacement_date: '',
					replacement_reason: '',
					replacement_url: '',
					examineDetailsList: [],
				},

				//暂存数据
				object: {
					staff_id: "",
					staff_name: "",
					project_id: "",
					project_name: ""
				},

				//表单验证
				rules: {
					staff_id: [{
						required: true,
						message: '请选择补卡人！',
						trigger: 'blur'
					}],
					replacement_date: [{
						required: true,
						message: '请选择补卡时间！',
						trigger: 'blur'
					}],
					replacement_reason: [{
						required: true,
						message: '请选择补卡原因！',
						trigger: 'blur'
					}],
				},

				//页面相关
				dialogVisible: false,
				dialogAuditorVisible: false

			};
		},
		methods: {
			//文件格式判断
			beforeAvatarUpload(file) {

				return true;
			},
			//图片上传
			handleAvatarSuccess(res, file) {
				this.ruleForm.replacement_url = res.data.fileUrl;
			},
			//设置确定
			saveChange(e) {
				this.ruleForm.staff_id = e.staff_id;
				this.ruleForm.staff_name = e.staff_name;
				this.dialogVisible = false;
			},
			StaffFind() {
				this.dialogVisible = true;
				this.showtxbm = true;
			},
			//添加
			AddAuditor() {
				this.$refs["ruleForm"].validate((valid) => {
					if (valid) {
						this.ruleForm.examineDetailsList = [];
						this.dialogAuditorVisible = true;
						this.$refs['SelectAuditor'].initialize();
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			async Add() {
				var url = 'cardReplacement/add';
				var record = {
					staff_id: this.ruleForm.staff_id,
					replacement_date: this.ruleForm.replacement_date,
					replacement_reason: this.ruleForm.replacement_reason,
					replacement_url: this.ruleForm.replacement_url,
					examineDetailsList: this.ruleForm.examineDetailsList,
					applicant_id: this.$globals.user.staff_id,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.Return();
					} else {
						this.$message.warning(data);
					}
				}
			},
			//修改
			UpdateAuditor() {
				this.$refs["ruleForm"].validate((valid) => {
					if (valid) {
						this.ruleForm.examineDetailsList = [];
						this.dialogAuditorVisible = true;
						this.$refs['SelectAuditor'].initialize();
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			async Update() {
				var url = 'cardReplacement/modify';
				var record = {
					id: this.ruleForm.id,
					staff_id: this.ruleForm.staff_id,
					replacement_date: this.ruleForm.replacement_date,
					replacement_reason: this.ruleForm.replacement_reason,
					replacement_url: this.ruleForm.replacement_url,
					examineDetailsList: this.ruleForm.examineDetailsList,
					applicant_id: this.$globals.user.staff_id,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.Return();
					} else {
						this.$message.warning(data);
					}
				}
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			Return() {
				this.dialogAuditorVisible = false;
				this.$parent.Return();
			}
		},
		created() {
			this.ruleForm = this.$parent.ruleForm;
		},
		watch: {
			"ruleForm.staff_id"(newValue) {
				this.object.staff_id = newValue;
			},
			"ruleForm.staff_name"(newValue) {
				this.object.staff_name = newValue;
			},
		}
	}
</script>

<style>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 190px;
		height: 150px;
		line-height: 150px;
		text-align: center;
	}

	.avatar {
		width: 190px;
		height: 150px;
		display: block;
	}
</style>



// WEBPACK FOOTER //
// Bksq_add.vue?44b28766